import { defineComponent as _defineComponent } from 'vue'
import { computed, inject, onMounted, Ref, ref } from 'vue';

import {
  NavBar,
  BaseText,
  Link,
  HeadingDisplay,
  ContentDisplay,
  DataTable,
  DataTableProps,
  ButtonContainer,
  ButtonPrimary
} from '@warrenbrasil/nebraska-web';
import { BackButton } from '@/modules/common/components/buttons';
import { SingleInputMoney } from '@/modules/common/components/SingleInputMoney';

import { IMarginAllocationPreview } from '@/modules/trade/services/margin-allocation';

import {
  EMarginAllocationSteps,
  formattedData
} from '@/modules/trade/views/MarginAllocation/helpers';

interface IData {
  balance: { value: number };
  isUpdatingLimits: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'Drawdown',
  setup(__props) {

const changeStep = inject('changeStep', (step: EMarginAllocationSteps) => ({
  step
}));
const updateDataForm = inject(
  'updateDataForm',
  (key: string, value: object) => ({
    key,
    value
  })
);

const dataForm = inject('dataForm') as Ref<IData>;
const marginAllocationPreview = inject(
  'marginAllocationPreview'
) as Ref<IMarginAllocationPreview>;

const balanceValue = ref(0);
const drawdownFormatted = ref('');
const drawdownValue = ref(0);

const tableData = computed(() => {
  return formattedData(
    marginAllocationPreview.value.variationTable,
    balanceValue.value,
    drawdownValue.value
  );
});

const tableColumns = [
  {
    label: 'Ativo',
    align: DataTableProps.Align.Left,
    getter: 'ticker'
  },
  {
    label: 'Exposição máxima',
    align: DataTableProps.Align.Right,
    getter: 'maxExpose'
  },
  {
    label: 'Variação',
    align: DataTableProps.Align.Right,
    getter: 'variation'
  }
];

const status = computed(() => {
  const maxPercent = (balanceValue.value * 0.7).toFixed(2);

  return drawdownValue.value > Number(maxPercent) ? 'error' : '';
});

const helperText = computed(() => {
  const maxPercent = (balanceValue.value * 0.7).toFixed(2);

  return drawdownValue.value > Number(maxPercent)
    ? 'Valor superior a 70% do saldo day trade'
    : '';
});

const maximumDrawdownButtons = computed(() => {
  return marginAllocationPreview.value.maximumDrawdownButtons.map(item => {
    const value = (item.value * balanceValue.value).toFixed(2);

    return {
      value: Number(value),
      formatted: item.formatted,
      type: 'SET'
    };
  });
});

const isDisabled = computed(() => {
  return drawdownValue.value <= 0 || status.value === 'error';
});

function goToTerms() {
  window.open(marginAllocationPreview.value.termsLink, '_blank');
}

function goToPolicy() {
  window.open(marginAllocationPreview.value.policyLink, '_blank');
}

function onChangeValue(data: { value: number; formatted: string }) {
  drawdownFormatted.value = data.formatted;
  drawdownValue.value = data.value;
}

function nextStep() {
  updateDataForm('drawdown', {
    value: drawdownValue.value,
    formatted: drawdownFormatted.value
  });

  changeStep(EMarginAllocationSteps.REVIEW);
}

function handleBack() {
  changeStep(EMarginAllocationSteps.BALANCE);
}

onMounted(() => {
  balanceValue.value = Math.floor(dataForm.value.balance.value);
});

return { __sfc: true,changeStep, updateDataForm, dataForm, marginAllocationPreview, balanceValue, drawdownFormatted, drawdownValue, tableData, tableColumns, status, helperText, maximumDrawdownButtons, isDisabled, goToTerms, goToPolicy, onChangeValue, nextStep, handleBack, NavBar, BaseText, Link, HeadingDisplay, ContentDisplay, DataTable, ButtonContainer, ButtonPrimary, BackButton, SingleInputMoney }
}

})